import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeSearchOverlayNews, setSearchOverlayQueryNews, searchNews } from '../../Reducers/actions/newsActions';
import Icon from '../Icon/Icon';
import './SearchOverlay.scss';

const SearchOverlayNews = () => {
  const dispatch = useDispatch();
  const visible = useSelector(state => state.news.searchOverlayOpen);
  const value = useSelector(state => state.news.searchOverlayQuery);

  // Only fetch on search icon click or Enter
  const handleSearch = () => {
    if (value && value.length >= 2) {
      dispatch(searchNews(value));
      dispatch(closeSearchOverlayNews());
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    dispatch(setSearchOverlayQueryNews(val));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleOverlayClick = () => {
    dispatch(closeSearchOverlayNews());
    // Do not clear the input value; keep the last submitted value
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    dispatch(closeSearchOverlayNews());
  };

  if (!visible) return null;
  return (
    <div className="search-overlay" onClick={handleOverlayClick}>
      <div className="search-overlay__bar in-overlay" onClick={e => e.stopPropagation()}>
        <input
          type="text"
          className="search-overlay__input"
          placeholder="Search for news or author"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoFocus
        />
        <span onClick={handleSearch} style={{ cursor: 'pointer' }}>
          <Icon alias="search" width={20} color="#777" className="search-overlay__icon" />
        </span>
        <button className="search-overlay__close" onClick={handleCloseClick}>
          <Icon alias="cross" width={20} color="#777" />
        </button>
      </div>
    </div>
  );
};

export default SearchOverlayNews; 